import axios from 'src/api/Api';
import {
    GET_ORDERS_LIST_DATA_SUCCESS,
    GET_ALL_ORDERS_LIST_DATA_SUCCESS,
    GET_ORDERS_LIST_DATA_FAILURE,
    GET_ALL_ORDERS_LIST_DATA_FAILURE,
    GET_SEARCH_RESULTS_ORDERS_LIST_DATA_SUCCESS,
    GET_SEARCH_RESULTS_ORDERS_LIST_DATA_FAILURE,
    GET_REFINED_ORDERS_LIST_DATA_SUCCESS,
    GET_REFINED_ORDERS_LIST_DATA_FAILURE,
    ORDERS_LIST_FILTERS_UPDATE,
    ORDERS_LIST_DATA_UPDATE,
    RESET_ORDER_LIST,
    GET_DENIED_ORDER_SUCCESS,
    GET_DENIED_ORDER_FAILURE,
    FILTERS_UPDATE,
    GET_DENIED_ORDER_FILTER_SUCCESS,
    GET_DENIED_ORDER_FILTER_FAILURE,
} from '../actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import { select } from 'redux-saga/effects';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import i18n from 'src/i18n';
import { act } from 'react';
import {
    ORDER_HISTORY_START_DATE,
    ORDER_HISTORY_END_DATE,
} from 'src/pages/more/pages/orderHistory';
const t = (key) => i18n.t(key);

const ORDER_HISTORY_SUPPORTED_SORT_PARAMS = ['submitDate'];
const getOrderHistorySortParam = (sortParam) =>
    ORDER_HISTORY_SUPPORTED_SORT_PARAMS.includes(sortParam)
        ? sortParam
        : 'submitDate';

const buildOrderHistoryFilterParams = (payLoadFilters) => {
    const filter = payLoadFilters?.filter || {};
    return {
        startDate: filter.startDate || ORDER_HISTORY_START_DATE,
        endDate: filter.endDate || ORDER_HISTORY_END_DATE,
        orderTypeFilter: filter.orderType || '',
        orderStatusCodesFilter: filter.orderStatusCode || '',
        districtFilter: filter.district || '',
        territoryFilter: filter.territory || '',
        accountFilter: filter.account || '',
        pageLimit: payLoadFilters?.pageLimit,
        pageNum: payLoadFilters?.pageNo,
        sortOrder: payLoadFilters?.sortOrder,
        sortParam: getOrderHistorySortParam(payLoadFilters?.sortParam),
    };
};

const filterValidation = (action, filtersList) => {
    const appliedQuickFilter = action.payload.appliedQuickFilter;
    const appliedCategory = action.payload.appliedCategory;
    const appliedOrderType = action.payload.appliedOrderType;
    const appliedOrderStatus = action.payload.appliedOrderStatus;
    let payLoadFilters = action.payload.filters;
    const isAwaitingPo = action.payload.isAwaitingPo;
    const isAwaitingPOStatusCode = action.payload.isAwatingPOStatusCode;

    const checkQuickFilterEmpty =
        Object.keys(appliedQuickFilter).length === 0 &&
        appliedQuickFilter.constructor === Object;

    let setOrderStatus = '';
    let setOrdertype = '';
    let isCallAPI = false;

    const newFilterList = filtersList.filters;
    const orderType = payLoadFilters.filter.orderType;

    if (appliedCategory.categoryName === 'My Denied Usage Overrides' || 
        appliedCategory.categoryName === t('orders.orderQuickFilters.deniedUsageOverrides.name')) {
        isCallAPI = true;
    }
    // Handle All Orders category
    else if (
        appliedCategory.categoryName ===
        t('orders.orderListFilterDropDown.all.categoryName')
    ) {
        isCallAPI = true;
        if (appliedOrderType !== '') {
            setOrdertype = appliedOrderType;
        }
        if (appliedOrderStatus !== '') {
            setOrderStatus = appliedOrderStatus;
        }
        if (isAwaitingPo) {
            let checkOrderStatus = false;
            const splitAppliedOrderStatus =
                appliedOrderStatus !== '' ? appliedOrderStatus.split(',') : [];
            if (splitAppliedOrderStatus.length > 0) {
                checkOrderStatus = splitAppliedOrderStatus.includes(
                    isAwaitingPOStatusCode
                );
            }
            if (!checkOrderStatus) {
                splitAppliedOrderStatus.push(isAwaitingPOStatusCode);
                setOrderStatus = splitAppliedOrderStatus.join(',');
            }
        }
    } else if (
        appliedCategory.categoryName ===
        t('orders.orderListFilterDropDown.drafts')
    ) {
        setOrderStatus = appliedCategory.orderType;
        if (appliedQuickFilter?.isDefault && appliedQuickFilter.isDefault) {
            setOrdertype = appliedOrderType;
            isCallAPI = true;
        } else {
            setOrdertype = appliedQuickFilter.statusNotes.join(',');
            isCallAPI = true;
        }
    } else {
        const orderTypes = orderType.split(',');
        const orderDescription = [];
        setOrdertype = appliedCategory.orderType;
        if (
            checkQuickFilterEmpty ||
            (appliedQuickFilter?.isDefault && appliedQuickFilter.isDefault)
        ) {
            setOrderStatus = appliedOrderStatus;
            isCallAPI = true;
        } else {
            const filtersIndex = newFilterList?.filter((x) =>
                orderTypes?.includes(x.orderType)
            );
            const filtersList = filtersIndex?.reduce(
                (accumulator, currentValue) => {
                    return [...accumulator, ...(currentValue?.orderStatusList || [])];
                },
                []
            );
            appliedQuickFilter?.statusNotes?.length > 0 &&
                orderDescription.push(...appliedQuickFilter.statusNotes);
            var selectedFilterIndex;
            if (action?.payload?.filters?.filter?.deniedOverrides) {
                selectedFilterIndex = filtersList.findIndex(() => {
                    return orderDescription.includes('Usage');
                });
            } else {
                selectedFilterIndex = filtersList.findIndex((order) => {
                    return orderDescription.includes(order.description);
                });
            }
            setOrderStatus =
                selectedFilterIndex >= 0
                    ? filtersList[selectedFilterIndex]?.code
                    : '';
            isCallAPI = selectedFilterIndex >= 0 ? true : false;
        }
    }

    return {
        isCallAPI:
            appliedCategory.categoryName ===
                t('orders.orderQuickFilters.deniedUsageOverrides.name') &&
            newFilterList.length === 0
                ? true
                : isCallAPI,
        setOrderStatus:
            action?.payload?.filters?.filter?.deniedOverrides ||
            action?.toggleEnabled
                ? '12347,12348'
                : setOrderStatus,
        setOrdertype: setOrdertype,
    };
};

export function* getFilterAndOrderListData(action) {
      const { isActionItem, notificationFailure, isFromOrderHistory, ...restPayload } = action.payload;
      let url = '';
    if(isFromOrderHistory)
    {
      url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderHistoryList`;
    }
    else{
     url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderList`;
    }
    let payLoadFilters = isFromOrderHistory?restPayload:action.payload.filters;

    const initialFilterPayload = {
        ...payLoadFilters,
        pageLimit: 1,
        pageNo: 0,
    };
let filtersList = {};
    try {
        //1st Call to update Only Filter
         if(isFromOrderHistory)
    {

        const orderHistoryCountPayload = {
            ...(payLoadFilters.filters || {}),
            filter: {
                ...(payLoadFilters.filters?.filter || {}),
            },
            pageLimit: 1,
            pageNo: 0,
        };
        filtersList = yield axios
            .get(url, {
                params: buildOrderHistoryFilterParams(orderHistoryCountPayload),
            })
            .then((response) => response.data);
    }
         else
         {
   filtersList = yield axios
            .post(url, initialFilterPayload)
            .then((response) => response.data);
         }
        const checkFilterRecords =
            filtersList.statusCode === '10001' ? true : false; //10001 Records Found

        if (!checkFilterRecords) {
            filtersList = { ...filtersList, filters: [] };
        }

        yield put({ type: ORDERS_LIST_FILTERS_UPDATE, data: filtersList });

        const { isCallAPI, setOrdertype, setOrderStatus } = filterValidation(
            action,
            filtersList
        );

        // Check if this is a denied overrides request directly from the category or toggle
        const isDeniedOverridesRequest = 
            action.toggleEnabled || 
            (action.payload.appliedCategory && 
             action.payload.appliedCategory.categoryName === 'My Denied Usage Overrides');
        
        if (isDeniedOverridesRequest) {
            // For denied overrides, always set the correct filter parameters
            payLoadFilters = {
                ...payLoadFilters,
                filter: {
                    ...payLoadFilters.filter,
                    deniedOverrides: true,
                },
            };
        } else if (isCallAPI) {
            payLoadFilters = {
                ...payLoadFilters,
                filter: {
                    ...payLoadFilters.filter,
                    orderType:
                        setOrdertype === 'ALL_ORDERS' ? '' : setOrdertype,
                    orderStatusCode: setOrderStatus,
                },
            };
        }

        if (isCallAPI || isDeniedOverridesRequest) {
            //Step -1 :- If Order Status Filter Count is present and greater than Zero
         let result = '';
            if(isFromOrderHistory)
            {
              // For Order History the applied filter (dates/district/territory/account)
              // and paging/sort live under payLoadFilters.filters, while the computed
              // orderType/orderStatusCode (and deniedOverrides) overrides live on
              // payLoadFilters.filter. Merge them so the actual list call honors the
              // applied date range instead of falling back to the full range.
              const orderHistoryListPayload = {
                  ...(payLoadFilters.filters || {}),
                  filter: {
                      ...(payLoadFilters.filters?.filter || {}),
                      ...(payLoadFilters.filter || {}),
                  },
              };
              result = yield axios
                .get(url, { params: buildOrderHistoryFilterParams(orderHistoryListPayload) })
                .then((response) => response.data);
            }else{
              result = yield axios
                .post(url, payLoadFilters)
                .then((response) => response.data);
            }
            const checkOrderListRecords =
                result.statusCode === '10001' ? true : false; //10001 Records Found
            
            // Handle denied overrides results consistently
            if (isDeniedOverridesRequest || action?.payload?.filters?.filter?.deniedOverrides) {
                result = {
                    ...result,
                    totalDeniedOrder:
                        result?.totalSearcResults >= 0
                            ? result?.totalSearcResults
                            : 0,
                };
            } else {
                // When switching away from denied overrides, reset totalDeniedOrder to avoid confusion
                result = {
                    ...result,
                    totalDeniedOrder: 0,
                };
            }
            
            if (!checkOrderListRecords) {
                result = { ...result, orderList: [] };
            }
            // if (action.isDeniedOverrideToggle) {
            //     result = {
            //         ...result,
            //         isDeniedOverrideToggle: action.isDeniedOverrideToggle,
            //     };
            //     yield put({ type: FILTERS_UPDATE, data: result });
            // }
            yield put({ type: ORDERS_LIST_DATA_UPDATE, data: result });
        } else {
            //Step -2 :- If Order Status Filter Count is Not present and equal to zero
            yield put({ type: RESET_ORDER_LIST });
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_REFINED_ORDERS_LIST_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* getOrderListData(action) {
      const { isActionItem, notificationFailure, isFromOrderHistory, ...restPayload } = action.payload;
    const params = convertObjectToQueryParams({
        ...restPayload,
        startDate: ORDER_HISTORY_START_DATE,
        endDate: ORDER_HISTORY_END_DATE,
    });
   
    const appliedUserFilters = yield select(
        (state) => state.appliedOrdersFilterReducer
    );
    let url = '';
if(isFromOrderHistory)
{
    url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderHistoryList?${params}`;
}else
{

     url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderList?${params}&assignedFlag=${
        Object.prototype.hasOwnProperty.call(
            appliedUserFilters.filter,
            'assignedFlag'
        )
            ? appliedUserFilters.filter.assignedFlag
            : true
    }`;
}
    try {
        let result = yield axios.get(url).then((response) => response.data);
        let orderCheckRecords = result.statusCode === '10001' ? true : false; //10001 Records Found
        if (!orderCheckRecords) {
            result = { ...result, orderList: [] };
        }
        yield put({ type: GET_ORDERS_LIST_DATA_SUCCESS, data: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_ORDERS_LIST_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* getAllOrderListData(action) {
  
    const { isActionItem, notificationFailure, isFromOrderHistory, ...restPayload } = action.payload;
    const params = isFromOrderHistory
        ? convertObjectToQueryParams({
            ...restPayload,
            sortParam: getOrderHistorySortParam(restPayload.sortParam),
            startDate: ORDER_HISTORY_START_DATE,
            endDate: ORDER_HISTORY_END_DATE,
        })
        : convertObjectToQueryParams({ ...action.payload });
    const appliedUserFilters = yield select(
        (state) => state.appliedOrdersFilterReducer
    );
    let url = '';
if(isFromOrderHistory)
{
  url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderHistoryList?${params}`;
}else{
     url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderList?${params}&assignedFlag=${
        Object.prototype.hasOwnProperty.call(
            appliedUserFilters.filter,
            'assignedFlag'
        )
            ? appliedUserFilters.filter.assignedFlag
            : true
    }`;
}
    try {
        let result = yield axios.get(url).then((response) => response.data);
        let orderCheckRecords = result.statusCode === '10001' ? true : false; //10001 Records Found
        if (!orderCheckRecords) {
            result = { ...result, allOrderList: [] };
        }
        yield put({ type: GET_ALL_ORDERS_LIST_DATA_SUCCESS, data: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_ALL_ORDERS_LIST_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* getSearchOrdersList(action) {
      const { isActionItem, notificationFailure, isFromOrderHistory, ...restPayload } = action.payload;
    let url = '';
if(isFromOrderHistory)
{
  url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderHistoryList`;
}else{
     url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderList`;
}
    try {
        let result = '';
        if (isFromOrderHistory) {
            const { searchParams = {}, pageNo, ...restSearch } = restPayload;
            const accountSearchTerm = (searchParams.account || '')
                .toString()
                .trim();
            const isAccountNameSearch =
                accountSearchTerm !== '' && !/^\d+$/.test(accountSearchTerm);
            const physicianSearchActive =
                (searchParams.physician || '').toString().trim() !== '';
            const patientNameSearchActive =
                (searchParams.patientName || '').toString().trim() !== '';
            const procedureSearchActive =
                (searchParams.procedureDescription || searchParams.procedure || '')
                    .toString()
                    .trim() !== '';
            const backendSearchParams = { ...searchParams };
            if (isAccountNameSearch) {
                delete backendSearchParams.account;
            }
            if (physicianSearchActive) {
                delete backendSearchParams.physician;
            }
            if (patientNameSearchActive) {
                delete backendSearchParams.patientName;
            }
            if (procedureSearchActive) {
                delete backendSearchParams.procedure;
                delete backendSearchParams.procedureDescription;
            }
            const baseParams = {
                ...restSearch,
                ...backendSearchParams,
                startDate: ORDER_HISTORY_START_DATE,
                endDate: ORDER_HISTORY_END_DATE,
            };
            const needsFullWindow =
                isAccountNameSearch ||
                physicianSearchActive ||
                patientNameSearchActive ||
                procedureSearchActive;
            if (needsFullWindow) {
                const fullWindowPageLimit = 200;
                let currentPageNum = 0;
                let aggregatedOrders = [];
                let lastResponse = {};
                let keepFetching = true;
                let safetyCounter = 0;
                while (keepFetching && safetyCounter < 25) {
                    const pageResponse = yield axios
                        .get(url, {
                            params: {
                                ...baseParams,
                                pageNum: currentPageNum,
                                pageLimit: fullWindowPageLimit,
                            },
                        })
                        .then((response) => response.data);
                    lastResponse = pageResponse;
                    const pageOrders = pageResponse?.orderList || [];
                    aggregatedOrders = aggregatedOrders.concat(pageOrders);
                    keepFetching =
                        pageResponse?.statusCode === '10001' &&
                        pageOrders.length === fullWindowPageLimit;
                    currentPageNum += 1;
                    safetyCounter += 1;
                }
                result = {
                    ...lastResponse,
                    statusCode:
                        aggregatedOrders.length > 0
                            ? '10001'
                            : lastResponse?.statusCode,
                    orderList: aggregatedOrders,
                    totalSearcResults: aggregatedOrders.length,
                };
            } else {
                result = yield axios
                    .get(url, {
                        params: { ...baseParams, pageNum: pageNo },
                    })
                    .then((response) => response.data);
            }
        } else {
            result = yield axios
                .post(url, action.payload)
                .then((response) => response.data);
        }
        const searchRecords = result.statusCode === '10001' ? true : false; //10001 Records Found
        if (!searchRecords) {
            result = { ...result, orderList: [], totalSearcResults: 0 };
        }

        const patientSearchText =
            action?.payload?.searchParams?.patientName?.trim()?.toLowerCase() ||
            '';
        const procedureSearchText =
            (action?.payload?.searchParams?.procedureDescription ||
                action?.payload?.searchParams?.procedure ||
                '')
                .trim()
                .toLowerCase();
        const accountNameSearchTerm =
            action?.payload?.searchParams?.account?.trim() || '';
        const accountNameSearchText =
            isFromOrderHistory &&
            accountNameSearchTerm !== '' &&
            !/^\d+$/.test(accountNameSearchTerm)
                ? accountNameSearchTerm.toLowerCase()
                : '';
        const physicianSearchTerm =
            action?.payload?.searchParams?.physician?.trim() || '';
        const physicianSearchText =
            isFromOrderHistory && physicianSearchTerm !== ''
                ? physicianSearchTerm.toLowerCase()
                : '';

        if (
            patientSearchText ||
            procedureSearchText ||
            accountNameSearchText ||
            physicianSearchText
        ) {
            const orderList = result?.orderList || [];
            const hasPatientData = orderList.some(
                (order) =>
                    (order?.patientName || '').toString().trim().length > 0
            );
            const hasProcedureData = orderList.some(
                (order) =>
                    (
                        order?.procedureDescription ||
                        order?.procedure ||
                        order?.procedureName ||
                        order?.procedureType ||
                        ''
                    )
                        .toString()
                        .trim().length > 0
            );
            const hasAccountData = orderList.some(
                (order) =>
                    (order?.accountName || '').toString().trim().length > 0
            );
            const hasPhysicianData = orderList.some(
                (order) =>
                    (
                        order?.physicianDisplayName ||
                        order?.physicianName ||
                        order?.physician ||
                        ''
                    )
                        .toString()
                        .trim().length > 0
            );

            const filteredOrderList = orderList.filter((order) => {
                const orderPatientName =
                    (order?.patientName || '').toString().trim().toLowerCase();
                const orderProcedureText =
                    (
                        order?.procedureDescription ||
                        order?.procedure ||
                        order?.procedureName ||
                        order?.procedureType ||
                        ''
                    )
                        .toString()
                        .trim()
                        .toLowerCase();
                const orderAccountName =
                    (order?.accountName || '').toString().trim().toLowerCase();
                const orderPhysicianName =
                    (
                        order?.physicianDisplayName ||
                        order?.physicianName ||
                        order?.physician ||
                        ''
                    )
                        .toString()
                        .trim()
                        .toLowerCase();

                const patientMatched = patientSearchText
                    ? hasPatientData
                        ? orderPatientName.includes(patientSearchText)
                        : true
                    : true;
                const procedureMatched = procedureSearchText
                    ? hasProcedureData
                        ? orderProcedureText.includes(procedureSearchText)
                        : true
                    : true;
                const accountMatched = accountNameSearchText
                    ? hasAccountData
                        ? orderAccountName.includes(accountNameSearchText)
                        : true
                    : true;
                const physicianMatched = physicianSearchText
                    ? hasPhysicianData
                        ? orderPhysicianName.includes(physicianSearchText)
                        : true
                    : true;

                return (
                    patientMatched &&
                    procedureMatched &&
                    accountMatched &&
                    physicianMatched
                );
            });

            result = {
                ...result,
                orderList: filteredOrderList,
                totalSearcResults: filteredOrderList.length,
            };
        }

        yield put({
            type: GET_SEARCH_RESULTS_ORDERS_LIST_DATA_SUCCESS,
            data: result,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_SEARCH_RESULTS_ORDERS_LIST_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* refinedOrderListData(action) {
      const { isActionItem, notificationFailure, isFromOrderHistory, ...restPayload } = action.payload;
   
    let url = '';
if(isFromOrderHistory)
{
  url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderHistoryList`;
}else{
    url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderList`;
}
    // Check if this is a denied overrides request
    const isDeniedOverridesRequest = action?.payload?.filter?.deniedOverrides === true;
    
    if (isDeniedOverridesRequest) {
        action.payload = {
            ...action.payload,
            filter: {
                ...action.payload.filter,
            }
        };
    }
let result='';
    try {
      if(isFromOrderHistory)
        {
result = yield axios
            .get(url, { params: buildOrderHistoryFilterParams(restPayload) })
            .then((response) => response.data);
        } 
        else{
             result = yield axios
            .post(url, action.payload)
            .then((response) => response.data);
}
        const checkRecords = result.statusCode === '10001' ? true : false; //10001 Records Found
        if (isDeniedOverridesRequest) {
            result = { ...result, totalDeniedOrder: result.totalSearcResults };
        }
        if (!checkRecords) {
            result = { ...result, orderList: [], totalSearcResults: 0 };
        }

        yield put({ type: GET_REFINED_ORDERS_LIST_DATA_SUCCESS, data: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_REFINED_ORDERS_LIST_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* deniedOrderCount(action) {
      const { isActionItem, notificationFailure, isFromOrderHistory, ...restPayload } = action.payload;
    
    let url = '';
if(isFromOrderHistory)
{
  url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderHistoryList`;
}else{
     url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderList`;
}
    try {
        let result = yield axios
            .post(url, isFromOrderHistory?{
        ...restPayload,
        startDate: ORDER_HISTORY_START_DATE,
        endDate: ORDER_HISTORY_END_DATE,
    } : action.payload)
            .then((response) => response.data);
        const checkRecords = result.statusCode === '10001' ? true : false; //10001 Records Found
        result = {
            totalDeniedOrder:
                result?.totalSearcResults >= 0 ? result?.totalSearcResults : 0,
        };
        if (!checkRecords) {
            result = { ...result, totalDeniedOrder: 0 };
        }

        yield put({ type: GET_DENIED_ORDER_SUCCESS, data: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_DENIED_ORDER_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* deniedOrderFilter(action) {
      const { isActionItem, notificationFailure, isFromOrderHistory, ...restPayload } = action.payload;
   
    let url = '';
if(isFromOrderHistory)
{
  url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderHistoryList`;
}else{
     url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderList`;
}
    try {
        const payload = {
            ...action.payload,
            filter: {
                ...action.payload.filter,
                deniedOverrides: true,
            }
        };
        
        let result = yield axios
            .post(url,isFromOrderHistory?{
        ...restPayload,
        startDate: ORDER_HISTORY_START_DATE,
        endDate: ORDER_HISTORY_END_DATE,
        filter: {
                ...action.payload.filter,
                deniedOverrides: true,
            }
    } : payload)
            .then((response) => response.data);
        const checkRecords = result.statusCode === '10001' ? true : false; //10001 Records Found

        if (checkRecords) {
            // Also dispatch an action to update the denied order count
            yield put({
                type: GET_DENIED_ORDER_SUCCESS,
                data: {
                    totalDeniedOrder: result.totalSearcResults >= 0 ? result.totalSearcResults : 0,
                },
            });
        } else {
            result = { ...result, totalDeniedOrder: 0 };
        }

        yield put({
            type: GET_DENIED_ORDER_FILTER_SUCCESS,
            data: result.statusCode === '10011' ? [] : result?.filters,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_DENIED_ORDER_FILTER_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
